/* Kitty Paradise — interactive effects */

/* ── Glitter Canvas ── */
(function () {
  const canvas = document.getElementById('kitty-glitter-canvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  const colors = ['#ff69b4','#ffb6c1','#ffd700','#ffffff','#ff1493','#ffc0cb'];
  let particles = [];

  function resize() {
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  resize();
  window.addEventListener('resize', resize);

  function Particle(x, y) {
    this.x       = x ?? Math.random() * canvas.width;
    this.y       = y ?? Math.random() * canvas.height;
    this.size    = Math.random() * 3 + 1;
    this.speedY  = -(Math.random() * 1.5 + 0.5);
    this.speedX  = (Math.random() - 0.5) * 1;
    this.opacity = Math.random();
    this.fadeDir = Math.random() > 0.5 ? 1 : -1;
    this.color   = colors[Math.floor(Math.random() * colors.length)];
  }

  Particle.prototype.update = function () {
    this.y += this.speedY;
    this.x += this.speedX;
    this.opacity += this.fadeDir * 0.02;
    if (this.opacity >= 1 || this.opacity <= 0) this.fadeDir *= -1;
    if (this.y < -10) {
      this.y = canvas.height + 10;
      this.x = Math.random() * canvas.width;
    }
  };

  Particle.prototype.draw = function () {
    ctx.save();
    ctx.globalAlpha = Math.max(0, this.opacity);
    ctx.fillStyle   = this.color;
    ctx.translate(this.x, this.y);
    ctx.beginPath();
    for (let i = 0; i < 5; i++) {
      ctx.lineTo(
        Math.cos((18 + i * 72) * Math.PI / 180) * this.size,
        -Math.sin((18 + i * 72) * Math.PI / 180) * this.size
      );
      ctx.lineTo(
        Math.cos((54 + i * 72) * Math.PI / 180) * this.size * 0.4,
        -Math.sin((54 + i * 72) * Math.PI / 180) * this.size * 0.4
      );
    }
    ctx.closePath();
    ctx.fill();
    ctx.restore();
  };

  for (let i = 0; i < 80; i++) particles.push(new Particle());

  document.addEventListener('mousemove', function (e) {
    if (particles.length < 300) {
      particles.push(new Particle(e.clientX, e.clientY));
      particles.push(new Particle(e.clientX, e.clientY));
    }
  });

  function animate() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    particles.forEach(p => { p.update(); p.draw(); });
    requestAnimationFrame(animate);
  }
  animate();
})();

/* ── Floating Hearts ── */
(function () {
  const container = document.getElementById('kitty-hearts');
  if (!container) return;
  const symbols = ['♡','💕','💖','💗','🎀','🌸','✨'];
  for (let i = 0; i < 20; i++) {
    const el = document.createElement('span');
    el.textContent = symbols[Math.floor(Math.random() * symbols.length)];
    el.style.cssText = [
      'position:absolute',
      'left:' + Math.random() * 100 + '%',
      'font-size:' + (Math.floor(Math.random() * 20) + 12) + 'px',
      'opacity:0.25',
      'animation:kittyFloatUp ' + (Math.random() * 15 + 10) + 's linear ' + (Math.random() * 10) + 's infinite',
    ].join(';');
    container.appendChild(el);
  }
})();

/* ── Scroll Reveal ── */
(function () {
  const els = document.querySelectorAll('.kitty-reveal');
  if (!els.length) return;
  const io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry, i) {
      if (entry.isIntersecting) {
        setTimeout(function () {
          entry.target.classList.add('kitty-visible');
        }, i * 100);
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  els.forEach(function (el) { io.observe(el); });
})();
